export default __webpack_public_path__ + "static/media/TheWorldJapan_00.36491dbc.png";